const tipoAfiliaciones = [
    {cod: 0, tipo: "Dependiente"},
    {cod: 1, tipo: "Independiente"},
    {cod: 2, tipo: "Beneficiario"},
    {cod: 3, tipo: "Régimen especial"},
    {cod: 4, tipo: "Subsidiado"}
]

export default tipoAfiliaciones;